import { serviceSlice } from "../../app/serviceSlice";
import { User, SiteUser, NewUserType, assignGroupsToUserType } from "./types";
import { userManagementService } from "./nebula.port";

export const extendedApiSlice = serviceSlice
    .enhanceEndpoints({ addTagTypes: ["USER_MANAGEMENT_SITES"] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getUsers: builder.query<{ usersFromSites: SiteUser[]; usersFromTrials: User[] }, void>({
                query: () => userManagementService.getUsers,
            }),
            getAvailableRoles: builder.query<string[], void>({
                query: () => userManagementService.getRoles,
            }),
            checkUserExists: builder.query<{ exists: boolean }, string>({
                query: (email) => () => userManagementService.checkUserExists(email),
            }),
            getSites: builder.query<{ name: string; uuid: string }[], string>({
                query: (trialId) => () => userManagementService.getSites(trialId),
                providesTags: (_result, _error, trialId) => [{ type: "USER_MANAGEMENT_SITES", id: trialId }],
            }),
            getTrialsUserManagement: builder.query<{ name: string; uuid: string }[], void>({
                query: () => () => userManagementService.getTrialsUserManagement(),
            }),
            createUser: builder.mutation<any, NewUserType>({
                query: (user) => () => userManagementService.createUser(user),
            }),
            updateUser: builder.mutation<User, { userId: string; user: Partial<User & SiteUser> }>({
                query:
                    ({ userId, user }) =>
                    () =>
                        userManagementService.updateUser(userId, user),
            }),
            assignGroupsToUser: builder.mutation<
                assignGroupsToUserType[],
                { userId: string; affiliationType: string; assignTo: string[] }
            >({
                query:
                    ({ userId, affiliationType, assignTo }) =>
                    () =>
                        userManagementService.assignGroupsToUser(userId, affiliationType, assignTo),
            }),
            editUserRoles: builder.mutation<{ userId: string; roles: string[] }, { userId: string; roles: string[] }>({
                query:
                    ({ userId, roles }) =>
                    () =>
                        userManagementService.editUserRoles(userId, roles),
            }),
            createSite: builder.mutation<
                { name: string; uuid: string },
                { name: string; countryCode: string; trialId: string }
            >({
                query: (site) => () => userManagementService.createSite(site),
                invalidatesTags: (_result, _error, site) => [{ type: "USER_MANAGEMENT_SITES", id: site.trialId }],
            }),
        }),
    });

export const {
    useGetUsersQuery,
    useGetAvailableRolesQuery,
    useCheckUserExistsQuery,
    useGetSitesQuery,
    useGetTrialsUserManagementQuery,
    useCreateUserMutation,
    useUpdateUserMutation,
    useAssignGroupsToUserMutation,
    useEditUserRolesMutation,
    useCreateSiteMutation,
} = extendedApiSlice;
